function showHiddenText(){
    const hiddenText = document.querySelector('.hidden-text');
    hiddenText.classList.add('on');
}
export default showHiddenText;


